import { Component, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../api.service';
import { AuthService } from '../auth.service';
import { BottomSheet } from '../bottom.sheet';
import { HandlerService } from '../handler.service';
import { LocationService } from '../location.service';

@Component({
  selector: 'app-create-feedback',
  templateUrl: './create-feedback.component.html',
  styleUrls: ['./create-feedback.component.scss'],
})
export class CreateFeedbackComponent  {
  name;
  description;
  orgs:any=[];
  services: any = [];
  loader: boolean = true;
  id;
  edit: boolean = false;
  item: any = {};
  qtn: boolean = false;
  items: any = [];
  questions: any = [];
  providerServiceId;
  providerServiceName;
  active:boolean= true;
  orgId= localStorage.getItem('organizationId');
  newOrgObject:any;
  orgName;
  category;
  constructor(private service: ApiService,
    public handler: HandlerService,
    public router: Router,
    public translate: TranslateService,
    public auth: AuthService,  public location: LocationService, private bottomSheet: MatBottomSheet) { }

    async ionViewWillEnter() {
      // if(localStorage.getItem('dashBoardOrgId')){
      //   this.orgId= localStorage.getItem('dashBoardOrgId')
      // }
      sessionStorage.setItem('orgId',this.orgId);
      this.newOrgObject=JSON.parse(localStorage.getItem('capabilityOrg'));
      let obj=[];
      //  this.newOrgObject.map(res => {
      //  let x = this.auth.getOrgCapabilities( res.id, 'SP');
      //  if(x==true){
      //  obj.push(res)
      //  }
      // }) 
      // this.newOrgObject=obj;
      // this.newOrgObject.map(res => {
      //   if (res.id == this.orgId) {
      //   this.orgName = res.name;
      //   }
      //   })
     
      await this.service.getOrgCategory().subscribe(res => {
       if(res!=null){
        this.category = res;
        this.providerServiceName=res[0].name;
        this.providerServiceId=res[0].id;
        this.loader = false;
        if (url.includes('create-feedback')) {
          this.edit = false;
          setTimeout(() => {
            this.providerServiceId=this.category[0].id;
            this.providerServiceName=this.category[0].name;
          }, 500);
        }
       }else{
         this.loader = false;
       }    
      }, err => {
        this.loader = false;
        this.handler.err(err)
      });
  
      let url = window.location.href;
      this.id = window.location.href.split('/').pop();
      if (url.includes('edit-feedback')) {
        this.edit = true;
        this.loader = true;
        setTimeout(() => {
          this.service.getAssessment(this.id).subscribe((res: any) => {
            this.item = res;
            this.name = res.name;
            this.description = res.description;
            this.questions = res.questions;
            this.providerServiceId = res.providerServiceId;
            this.category.map(res1=>{
              if(res1.id==this.providerServiceId ){
                this.providerServiceName=res1.name;
              }
            })
            this.loader = false;
            this.active = res.activeInd;
          }, err => {
            this.loader = false;
            this.handler.err(err)
          })
          
        }, 500);
  
      }
   
  
    }
    next() {
      this.qtn = true;
      var len = this.questions.length;
      if (len > 0) {
        this.items = this.questions;
        this.items.map(res => Object.assign(res, { icon: 'clear' }))
        this.items[this.items.length - 1].icon = 'add';
      }
      else {
        this.items.push({ name: "", activeInd: true, icon: 'add' });
      }
    }
    add(data, i) {
      if (data.icon === "clear") {
        if(data.id){
          this.loader = true;
          this.service.deleteAssessmentQtn(this.id,data.id).subscribe(res => {
            this.items.splice(i, 1);
            this.loader = false;
          },
            err => {
              this.loader = false;
              this.handler.err(err);
            })
        }
        else{
        this.items.splice(i, 1);
        }
      }
      else {
        this.items[i].icon = "clear";
        this.items.push({ name: "", activeInd: true, icon: 'add' });
      }
    }
    prev() {
      this.qtn = false;
    }
    save() {
      if(this.providerServiceId){
      this.loader = true;
      this.items = this.items.filter(res => res.name != "");
      var questions = [];
      this.items.map(res => {
        questions.push({
          name: res.name,
          activeInd: res.activeInd
        })
      });
      if(this.name){
        this.name = this.name.toUpperCase();
      }
      if(this.description){
        this.description = this.description.toUpperCase();
      }
      var post = {
        activeInd: this.active,
        name: this.name,
        description: this.description,
        orgId: this.orgId,
        providerServiceId: this.providerServiceId,
        questions: questions,
        type: 2
      }
  
      this.service.createAssessment(post).subscribe(res => {
        this.loader = false;
        this.handler.toast.open('Feedback Created successfully', 'res');
        this.router.navigate(['/get-feedback']);
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
    }
    else{
      this.handler.res("Please Fill Mandatory Fields");
    }
    }
  
    editAssess() {
      this.loader = true;
      this.items = this.items.filter(res => res.name != "");
      var questions = [];
      this.items.map(res => {
        questions.push({
          id: res.id,
          name: res.name,
          activeInd: res.activeInd
        })
      });
      if(this.name){
        this.name = this.name.toUpperCase();
      }
      if(this.description){
        this.description = this.description.toUpperCase();
      }
      this.item.name = this.name;
      this.item.description = this.description;
      this.item.providerServiceId = this.providerServiceId;
      this.item.questions = questions;
      this.item.activeInd = this.active;
      this.service.editAssessment(this.id, this.item).subscribe(res => {
        this.loader = false;
        this.handler.toast.open('Feedback updated successfully', 'res');
        this.router.navigate(['/get-feedback']);
      }, err => {
        this.handler.err(err);
        this.loader = false;
      })
  
  
    }
    autoFill(){
      this.description = this.name;
    }
    openBottomSheet(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        this.providerServiceName = res.name;
        this.providerServiceId=res.id;
      });
    }
  
    save1(){
      if(this.items[0].name==''){
        this.handler.res("Please Create Atleast One Question");
      } else{
        this.save();
      }
        
      
    }
    openBottomSheetOrg(): void {
      const dialogRef = this.bottomSheet.open(BottomSheet,{
        data: this.category,
      });
      dialogRef.afterDismissed().subscribe((res) => {
        if(res){
          this.orgName = res.name;
          this.orgId=res.id;
          sessionStorage.setItem('orgId',res.id);
          this.service.getOrgCategory().subscribe(res => {
            this.category = res;
            this.providerServiceName=res[0].name;
            this.providerServiceId=res[0].id;
           
            this.loader = false;
          }, err => {
            this.loader = false;
            this.handler.err(err)
          });
          
        }
        
      });
    }
  
    ionViewWillLeave(){
      sessionStorage.clear();
      this.qtn=false;
      this.name=undefined;
      this.description=undefined;
      this.items=[];
     }
     
    
}
